import { render } from "./cpt-icon-quota-option.vue?vue&type=template&id=50f57f50"
import script from "./cpt-icon-quota-option.vue?vue&type=script&lang=js"
export * from "./cpt-icon-quota-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__